import { ActionIcon, Flex, Tooltip } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import { AppRoutes } from "../../models";
import {
  AdminSidebarTabs,
  adminSidebarTabsList,
  isAdminSidebarTab,
} from "./admin-navigation";

export function AdminSidebar() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: string }>();
  const activeSidebarTab = isAdminSidebarTab(tab)
    ? tab
    : AdminSidebarTabs.JOBS;

  return (
    <Flex direction={"column"}>
      {adminSidebarTabsList.map((item) => {
        return (
          <Tooltip key={item.name} label={item.tooltip} position="right">
            <ActionIcon
              mt={12}
              variant={item.name === activeSidebarTab ? "light" : "default"}
              style={{ border: "none" }}
              aria-label={item.tooltip}
              onClick={() =>
                navigate(`${AppRoutes.ADMIN_DASHBOARD}/${item.name}`)
              }
            >
              <item.icon style={{ width: "70%", height: "70%" }} />
            </ActionIcon>
          </Tooltip>
        );
      })}
    </Flex>
  );
}
